var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArchive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80078 12.8H15.2008",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 5.99995C2.40039 5.47953 2.40039 5.21933 2.44138 5.00295C2.60971 4.11436 3.27126 3.41974 4.11753 3.24299C4.32361 3.19995 4.57142 3.19995 5.06706 3.19995H12.0004H18.9337C19.4294 3.19995 19.6772 3.19995 19.8833 3.24299C20.7296 3.41974 21.3911 4.11436 21.5594 5.00295C21.6004 5.21933 21.6004 5.47953 21.6004 5.99995C21.6004 6.52037 21.6004 6.78057 21.5594 6.99695C21.3911 7.88554 20.7296 8.58016 19.8833 8.75691C19.6772 8.79995 19.4294 8.79995 18.9337 8.79995H12.0004H5.06706C4.57142 8.79995 4.32361 8.79995 4.11753 8.75691C3.27126 8.58016 2.60971 7.88554 2.44138 6.99695C2.40039 6.78057 2.40039 6.52037 2.40039 5.99995Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19922 8.80005V16.4364C3.19922 18.4935 3.19922 19.522 3.84359 20.1611C4.48795 20.8 5.52504 20.8 7.59922 20.8H8.69922H15.2992H16.3992C18.4734 20.8 19.5105 20.8 20.1548 20.1611C20.7992 19.522 20.7992 18.4935 20.7992 16.4364V8.80005",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArchive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_archive.6ad30d169f0981251b657706dd7a7755.svg";